import styled from '@emotion/styled';

import { breakpoints, fontWeight } from '~/src/styles';

interface LevelProps {
  color: string;
  showFill: boolean;
}

export const LevelContainer = styled.div`
  align-items: flex-end;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 22px;
  margin-left: auto;
`;

export const LevelOneView = styled.div<LevelProps>`
  background-color: ${props => props.color};
  border: solid ${props => props.color};
  border-radius: 3px;
  border-width: 1px;
  height: 6px;
  width: 6px;
`;

export const LevelTwoView = styled.div<LevelProps>`
  background-color: ${props => (props.showFill ? props.color : 'transparent')};
  border: solid ${props => props.color};
  border-radius: 3px;
  border-width: 1px;
  height: 12px;
  width: 6px;
`;

export const LevelThreeView = styled.div<LevelProps>`
  background-color: ${props => (props.showFill ? props.color : 'transparent')};
  border: solid ${props => props.color};
  border-radius: 3px;
  border-width: 1px;
  height: 18px;
  width: 6px;
`;

export const LevelName = styled.div`
  font-size: 10px;
  font-weight: ${fontWeight.regular};
  line-height: 10px;
  letter-spacing: 0em;
  text-align: right;
  color: white;
  margin-top: 5px;

  ${breakpoints.minDesktop} {
    font-size: 12px;
  }
`;
